module.exports = __webpack_public_path__ + "img/red_055.a493f4a8.png";